import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6d073ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "vrt-body"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Notifications confirmed!", -1))
const _hoisted_4 = { class: "vrt-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_VirtualRedTagTrailerGraphic = _resolveComponent("VirtualRedTagTrailerGraphic")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader, { outlined: "" }),
    (_ctx.assessmentId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1),
          _createVNode(_component_VirtualRedTagTrailerGraphic, {
            class: "vrt-graphic",
            state: _ctx.GraphicState.success
          }, null, 8, ["state"]),
          _createVNode(_component_fbx_button, {
            "button-text": "Return to Pointe",
            theme: "link",
            class: "italic vrt-return-link",
            onClick: _ctx.navigateToWelcome
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}